import './index.css'
import { WarningIcon } from '../Icons';

export default function ConfirmModal({ children, openModal, handleCloseModal, handleConfirm }: any) {

  return (
    <>
      <div className={`confirm-modal-overlay ${openModal ? '' : 'overlay__hidden'}`}></div>
      <div className={`confirm-modal ${openModal ? 'confirm-modal__visible' : 'confirm-modal__hidden'}`}>
        <div className='confirm-modal-section'>
          <WarningIcon className='confirm-modal-warning' />
          <div className='confirm-modal-children'>
            {children}
          </div>
          <div className='confirm-modal-btns'>
            <button className='confirm-modal-cancel-btn' onClick={handleCloseModal}>
              Cancelar
            </button>
            <button className='confirm-modal-confirm-btn' onClick={handleConfirm}>
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}